import { Image } from "@react-pdf/renderer";
import React from "react";

type Props = {
    // The team's avatar as an embedded data URL (see embeddedTeamLogo), or null to leave it off.
    logo: string | null | undefined;
    style: React.ComponentProps<typeof Image>["style"];
};

// A team's avatar for react-pdf, matching TeamAvatar on screen.
const PDFTeamAvatar: React.FC<Props> = ({ logo, style }) => {
    if (!logo) return null;

    return <Image style={style} src={logo} />;
};

export default PDFTeamAvatar;
